import { useRef, useState } from "react";

export default function Input({
  label,
  isLarge = false,
  prefix,
  required = false,
  className = "",
  id,
  name,
  disabled = false,
  children,
  value,
  defaultValue = "",
  onChange,
  pattern,
  ...inputProps
}) {
  const fieldRef = useRef(null);

  const isControlled = value !== undefined;

  const [internalValue, setInternalValue] =
    useState(defaultValue ?? "");

  const inputValue = isControlled
    ? value ?? ""
    : internalValue;

  const inputId = id || name;

  function handleChange(event) {
    if (!isControlled) {
      setInternalValue(event.target.value);
    }
    onChange?.(event);
  }

  function clearInput(sourceEvent) {
    if (!isControlled) {
      setInternalValue("");
    }

    const field = fieldRef.current;

    const changeTarget = {
      id: field?.id ?? inputId,
      name: field?.name ?? name,
      value: "",
      type:
        field?.type ??
        inputProps.type ??
        (isLarge ? "textarea" : "text"),
    };

    onChange?.({
      nativeEvent: sourceEvent?.nativeEvent,
      target: changeTarget,
      currentTarget: changeTarget,
      preventDefault() {
        sourceEvent?.preventDefault?.();
      },
      stopPropagation() {
        sourceEvent?.stopPropagation?.();
      },
    });
  }

  function renderChildren() {
    if (typeof children === "function") {
      return children({
        clearInput,
        value: inputValue,
      });
    }
    return children;
  }

  //Irrid nghamila component ghaliha <TextArea> ghax hawnhekk kerha.
  if (isLarge) {
    return (
      <div className={`flex min-h-0 flex-col ${className}`}>
        <div className="relative min-h-0 flex-1">
          <textarea
            {...inputProps}
            ref={fieldRef}
            id={inputId}
            name={name}
            value={inputValue}
            onChange={handleChange}
            required={required}
            disabled={disabled}
            className="block h-full min-h-0 w-full resize-none border border-b-4 px-4 py-2 outline-none transition focus:border-gray-500 disabled:cursor-not-allowed disabled:bg-gray-100"
          />
          <InputLabel htmlFor={inputId} label={label} required={required}/>
        </div>
        {renderChildren()}
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="relative">
        <div
          className={`flex min-w-0 overflow-hidden border border-b-4 bg-white transition focus-within:border-gray-500
            ${disabled ? "bg-gray-100" : ""}
          `}
        >
          {prefix && (
            <span className="hidden shrink-0 items-center whitespace-nowrap border-r border-gray-300 px-4 py-2 text-gray-500 select-none md:flex">
              {prefix}
            </span>
          )}

          <input
            {...inputProps}
            ref={fieldRef}
            id={inputId}
            name={name}
            value={inputValue}
            onChange={handleChange}
            required={required}
            disabled={disabled}
            pattern={pattern}
            className="block min-w-0 flex-1 border-0 bg-transparent px-4 py-2 outline-none disabled:cursor-not-allowed"
          />
        </div>
        <InputLabel htmlFor={inputId} label={label} required={required}/>
      </div>
      {renderChildren()}
    </div>
  );
}

function InputLabel({ htmlFor, label, required }) {
  return (
    <label htmlFor={htmlFor} className="absolute left-3 top-0 -translate-y-1/2 bg-white px-1 text-xs text-gray-500">
      {label}
      {required && (
        <span className="text-base text-red-500">
          {" "}*
        </span>
      )}
    </label>
  );
}